/**
 * Format date as compact: "01/15"
 */
export function formatDateCompact(dateString: string | null): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' });
}

/**
 * Format date as short: "Jan 15"
 */
export function formatDateShort(dateString: string | null): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/**
 * Format a date range using the specified format.
 */
export function formatDateRange(
  start: string | null,
  end: string | null,
  format: 'compact' | 'short' = 'compact'
): string {
  const formatter = format === 'compact' ? formatDateCompact : formatDateShort;
  if (!start || !end) return '';
  return `${formatter(start)} \u2013 ${formatter(end)}`;
}
